/* global _ */

/**
 * Internal dependencies
 */
import { apiRequest } from '@wpsimplepay/utils';
import { onPaymentFormError } from '@wpsimplepay/core/frontend/payment-forms';
import { getPaymentMethod } from '@wpsimplepay/pro/frontend/payment-methods';

const { hooks } = window.wpsp;
const { convertToDollars, formatCurrency } = window.spShared;

export let plaidHandler;

/**
 * Sets up a Stripe Elements iDEAL field and binds events.
 *
 * @link https://stripe.com/docs/stripe-js/reference#elements-create
 *
 * @param {jQuery} spFormElem Form element jQuery object.
 * @param {Object} formData Configured form data.
 */
export function setup( spFormElem, formData ) {
	const { cart } = spFormElem;
	const achDebit = getPaymentMethod( 'ach-debit' );
	const achDebitEl = spFormElem[ 0 ].querySelector( '.simpay-ach-debit-wrap' );

	if ( ! achDebitEl ) {
		return;
	}

	const { isTestMode, companyName } = formData;
	const { publicKey } = achDebitEl.dataset;
	const checkoutButtonEl = spFormElem[ 0 ].querySelector( '.simpay-checkout-btn-container' );

	// Handle toggling Checkout and ACH buttons.
	const tabs = spFormElem[ 0 ].querySelectorAll( '.simpay-form-tabs-toggles__toggle' );

	/**
	 * @param {Object} e Tab toggle click event.
	 */
	const maybeHideCheckoutButton = ( { target } ) => {
		checkoutButtonEl.style.display = 'simpay-payment-method-toggle-ach-debit' === target.id
			? 'none'
			: 'block';
	}

	if ( tabs ) {
		// Add a click event handler to each tab.
		_.each( tabs, ( tab ) => tab.addEventListener( 'click', maybeHideCheckoutButton ) );

		// On load.
		maybeHideCheckoutButton( {
			target: tabs[ 0 ],
		} );
	}

	try {
		// Throw error if no keys are defined.
		if ( undefined === publicKey || '' === publicKey ) {
			const { config: { i18n } } = achDebit;
			achDebitEl.innerHTML = i18n.api;

			return;
		}

		// Update ACH Debit button with amount.
		$( document.body ).on( 'simpayFinalizeCoreAmount', function() {
			const total = formatCurrency( convertToDollars( cart.getTotal() ), true );
			achDebitEl.querySelector( 'button span' ).innerHTML = total;
		} );

		/**
		 * Handles successful bank account authorization via Plaid Link.
		 *
		 * @param {String} publicToken Public token.
		 * @param {Object} metadata Metadata.
		 */
		const onSuccess = ( publicToken, { account_id: accountId } ) => {
			// Toggle buttons.
			achDebitEl.style.display = 'none';
			checkoutButtonEl.style.display = 'block';

			// Stop hiding Checkout button
			_.each( tabs, ( tab ) => tab.removeEventListener( 'click', maybeHideCheckoutButton ) );

			// Attach data.
			achDebitEl.dataset.publicToken = publicToken;
			achDebitEl.dataset.accountId = accountId;
		};

		/**
		 * Handles closure of Plaid Link.
		 *
		 * @param {String} publicToken Public token.
		 * @param {Object} metadata Metadata.
		 */
		const onExit = ( error, metadata ) => {
			// The user exited the Link flow.
			if ( error !== null ) {
				onPaymentFormError( error, spFormElem, formData );
			}
		}

		/**
		 * "Select Bank" button click handler.
		 *
		 * @param {Object} e Click event.
		 */
		achDebitEl.addEventListener( 'click', ( e ) => {
			e.preventDefault();

			// Setup handler.
			// Created on the fly to avoid issues with multiple on the same page.
			plaidHandler = Plaid.create( {
				env: true === isTestMode ? 'sandbox' : 'production',
				clientName: companyName,
				key: publicKey,
				product: [
					'auth',
				],
				selectAccount: true,
				onSuccess,
				onExit,
			} );

			plaidHandler.open();
		} );

		/**
		 * "Select Bank" button keypress handler.
		 *
		 * @param {Object} e Keyup event.
		 */
		achDebitEl.querySelector( 'button' ).addEventListener( 'keyup', ( e ) => {
			if ( 13 !== e.keyCode ) {
				return;
			}

			e.preventDefault();
			plaidHandler.open();
		} );

	} catch ( error ) {
		onPaymentFormError( error, spFormElem, formData );
	}
}
